import { render, staticRenderFns } from "./OrganizationReimagineModal.vue?vue&type=template&id=80ce8084&scoped=true&"
import script from "./OrganizationReimagineModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationReimagineModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ce8084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80ce8084')) {
      api.createRecord('80ce8084', component.options)
    } else {
      api.reload('80ce8084', component.options)
    }
    module.hot.accept("./OrganizationReimagineModal.vue?vue&type=template&id=80ce8084&scoped=true&", function () {
      api.rerender('80ce8084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/organization/modals/OrganizationReimagineModal.vue"
export default component.exports